/**
 * Pulse logo — CloakAI's shield silhouette with an EKG heartbeat line.
 * "The heartbeat of CloakAI's protection."
 */
export default function PulseLogo({ size = 32, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      role="img"
      aria-label="Pulse logo"
    >
      {/* Background — dark with subtle indigo tint */}
      <rect width="32" height="32" rx="8" fill="#111127" />

      {/* Shield silhouette — visible but subtle */}
      <path
        d="M16 5C11.5 5 8 8 8 12v8c0 2 1.2 4 3.2 5.2L16 27l4.8-1.8C22.8 24 24 22 24 20V12c0-4-4.5-7-8-7z"
        fill="#6366f1"
        fillOpacity="0.15"
        stroke="#6366f1"
        strokeWidth="0.8"
        strokeOpacity="0.4"
      />

      {/* EKG pulse line — the heartbeat running through the shield */}
      <path
        d="M5 17h4.5l1.5-4 2.5 10 2-6 1.5 3 1.5-3h8.5"
        stroke="#818cf8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />

      {/* Pulse dot — active heartbeat indicator */}
      <circle cx="16" cy="17" r="1.5" fill="#a5b4fc" />
    </svg>
  )
}

/** Minimal pulse icon — just the EKG line, no background. For inline use. */
export function PulseIcon({ size = 20, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M2 10h3l1.5-4 2.5 10 2-6 1.5 3 1.5-3h4"
        stroke="#6366f1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
